import React, { useState, useRef, Fragment } from "react";
import { TextField } from "@material-ui/core";
import { isNumber, isSpecial } from "../../lib/Common";

function CompanyName(props) {
  const classes = props.useStyles();
  const [errorText, setErrorText] = useState("");
  const [errorValue, setErrorValue] = useState(false);

  return (
    <Fragment>
      <TextField
        className={classes.TextField}
        fullWidth
        required
        inputRef={props.companyRef}
        error={errorValue}
        helperText={errorText}
        label="회사명"
        type="text"
        variant="filled"
        inputProps={{
          maxLength: 50,
        }}
        onBlur={(e) => {
          if (isNumber.test(e.target.value) || isSpecial.test(e.target.value)) {
            setErrorText("한글 / 영문만 입력 가능합니다.");
            setErrorValue(true);
            props.companyRef.current.focus();
          } else if (e.target.value.length <= 1) {
            setErrorText("2글자 이상 데이터 입력하세요.");
            setErrorValue(true);
            props.companyRef.current.focus();
          } else {
            setErrorText("");
            setErrorValue(false);
            props.onChangeCompanyName(e.target.value);
          }
        }}
        name="CompanyName"
        defaultValue={props.companyName}
      />
    </Fragment>
  );
}
export default CompanyName;
